import liveEtaConfiguration from "./liveEtaConfiguration.component";

const liveEtaConfigurationModule = angular
  .module("app.components.liveEtaConfiguration", [])
  .component("liveEtaConfiguration", liveEtaConfiguration);

export default liveEtaConfigurationModule;



// WEBPACK FOOTER //
// ./src/components/liveEtaConfiguration/liveEtaConfiguration.module.js